module.exports = __webpack_public_path__ + "static/media/bee.a722d897.png";